import styled, { css } from 'styled-components';
import { ColProps, DivderProps, RowItemProps, RowProps } from './commLayout.interface';

// Col

const Col = styled.div<ColProps>`
  ${({ justify, align }) => css`
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: ${justify};
    align-items: ${align};
  `}
`;

Col.defaultProps = {
  justify: 'flex-start',
  align: 'stretch',
};

// Row

const Row = styled.div<RowProps>`
  ${({ theme: { dir }, justify, align, flex, width }) => css`
    display: flex;
    flex-direction: ${dir === 'rtl' ? 'row-reverse' : 'row'};
    justify-content: ${justify};
    align-items: ${align};
    flex: ${flex};
    ${width ? `width: ${width}px` : 'width: 100%'};
  `}
`;

Row.defaultProps = {
  align: 'stretch',
  justify: 'flex-start',
  flex: 'unset',
  width: null,
};

// Row Item

const RowItem = styled.div<RowItemProps>`
  ${({ theme: { space }, flex, width, gap }) => css`
    ${flex ? `flex: ${flex};` : ''}
    ${width ? `min-width: ${width}px` : ''};
    ${width ? `max-width: ${width}px` : ''};

    &:not(&:last-child) {
      ${gap ? `margin-inline-end: ${gap === 'small' ? space.md : gap === 'medium' ? space.lg : gap === 'large'};` : gap}
    }
  `}
`;

RowItem.defaultProps = {
  flex: '1',
  width: null,
  gap: 'small',
};

// Divider

const Divider = styled.div<DivderProps>`
  ${({ theme: { space }, space: lineSpace }) => {
    const getMargin = () => {
      switch (lineSpace) {
        case 'small':
          return space.sm;
        case 'medium':
          return space.md;
        case 'large':
          return space.lg;
        default:
          return '';
      }
    };

    return css`
      border: 0.5px solid rgba(1, 3, 54, 0.08);
      display: block;
      margin: ${getMargin()} 0;
    `;
  }}
`;

Divider.defaultProps = {
  space: 'small',
};

export { Col, Divider, Row, RowItem };
